import CustomCard from '../../../../components/CustomCard';
import { EmailSubsectionChip } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import NotInformation from '../../../../components/NotInformation';
import React from "react";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: FullStack - IBL
 * @Email: kpozos@ibl.mx
 */
const UserWhiteListCards = ({
    t,
    results,
    setResults,
    searchElement,
    setSearchElement,
    option,
    rowsPerPage,
    setBodyForExport,
    setSimpleSearch,
    setSearch,
    whiteListRef,
    getData,
    getActionsButtons
}) => {

    return (
        <div className={"border-full-shades-300 border-radius-8px p-16px d-flex flex-column h-100 overflow-hidden"}>
            <div className={"row mt-4"}>
                <div className={"col-12 px-0"}>
                    <SearchSimple
                        id={"txt_uwlc_search"}
                        setSearchResults={setResults}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setBodyForExport={setBodyForExport}
                        contractorId={null}
                        supplierId={null}
                        setSimpleSearch={setSimpleSearch}
                        setSearch={setSearch}
                        callApi={() => getData(0, { searchElement})}
                        resetApi={() => getData(0, {searchElement: ''})}
                    />
                </div>
            </div>
            <div className={'border-bottom-shades-300 mb-3'} />

            {results?.content?.length > 0 ? (
                <div className={"flex-grow-1 min-h-0 overflow-y-auto"} ref={whiteListRef}>
                    <div className={"row"}>
                        {
                            results?.content?.map((user, index) => (
                                <div className='col-12 col-md-6 mb-3 px-1' key={user?.id}>
                                    <CustomCard classes='w-100 background-shades-50 border-radius-8px' classCard={"border-radius-8px"}>
                                        <div className='row'>
                                            <div className='d-flex flex-grow-1 minw-0 justify-content-between align-items-center p-0'>
                                                <div className={"mr-2"}>
                                                    <EmailSubsectionChip/>
                                                </div>
                                                <div className={'flex-grow-1 minw-0'}>
                                                    <CustomTooltip
                                                        text={user?.name}
                                                        classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row`}
                                                        showIfTruncated={true}
                                                    />
                                                </div>
                                                <div className={"d-flex align-content-end"}>{getActionsButtons(user, index)}</div>
                                            </div>
                                        </div>
                                    </CustomCard>
                                </div>
                            ))
                        }
                    </div>
                </div>
            ) : (
                <NotInformation
                    text={searchElement === "" ? `${t('no_records_available')}`: t("no_results_found")}
                    card={true}
                    containerRef={whiteListRef}
                    className={"h-100"}
                />
            )}
        </div>
    );
};

export default UserWhiteListCards;
